<template>
<section class="intro-with-form px-4 relative bg-primary-800">

    <div class="absolute left-0 top-0 w-full h-full overflow-hidden">
        <BackgroundImage parallax="0.1" position="bg-bottom" src="/wp-content/themes/landslide/img/mountains.png"></BackgroundImage>
    </div>

    <div class="max-w-7xl mx-auto relative z-10">
        <div class="grid gap-4 relative">

            <SmoothLoader class="left flex flex-col">
                <div class="max-w-4xl w-full mx-auto relative">
                    <div class="lead-line bg-primary-400" data-parallax="-0.1" aria-hidden="true"></div>
                    <div class="max-w-md">
                        <h2 v-if="headline" v-html="headline" class="text-gray-500 text-4xl vt:text-7xl font-headline font-bold mt-8 mb-4 vt:my-0"></h2>
                        <div v-if="blurb" class="text-gray-500 font-body text-lg" v-html="blurb"></div>
                        <div v-if="button" class="mt-8 w-full vt:w-2/3">
                            <Button variant="button-1" :url="button.url" :label="button.label"></Button>
                        </div>
                    </div>
                </div>
            </SmoothLoader>

            <div class="form-corner">
                <div v-if="form_embed_code" class="mt-8 vt:mt-0">
                    <h3 v-if="form_headline" class="vt:text-white antialiased tracking-wide text-gray-500 text-center text-lg font-headline font-bold uppercase mb-4" v-html="form_headline"></h3>
                    <div class="form-box bg-gray-500 rounded-xl p-8 shadow-xl relative z-10">
                        <p v-if="form_description" class="text-gray-500 font-medium font-body text-center px-2 mb-4" v-html="form_description"></p>
                        <div class="form-container" v-html="form_embed_code"></div>
                    </div>
                </div>
            </div>

            <SmoothLoader v-if="teaser_headline" class="teaser-corner relative pt-4 pb-8 vt:pt-24 vt:pb-0">
                <span class="teaser text-gray-500 text-4xl vt:text-7xl font-headline font-bold leading-tight block" v-html="teaser_headline"></span>
                <div class="lead-line bg-primary-400" aria-hidden="true"></div>
            </SmoothLoader>

        </div>
    </div>

</section>
</template>

<script>
import { computed } from 'vue';
export default {
    props: ['data'],
    setup(props) {

        const button = computed(() => {

            if (!props.data?.button_label || !props.data?.button_url) {
                return null;
            }

            return {
                label: props.data.button_label,
                url: props.data.button_url
            }

        });

        return {
            button,
            ...props.data
        }
    }
}
</script>
